import 'regenerator-runtime/runtime';
import { takeEvery } from 'redux-saga/effects';
import { PS20Logger } from '@ps20-frontend/logging';
import { App } from '@ps20-frontend/frontend-models';
import { migrateAngebotsdatumArray } from '@ps20-frontend/migrations';
import { GlobalActions, GlobalAction, WrappedSavedStatesLoaded, WrappedSavedStates } from '@ps20-frontend/shop-integration-redux';
import { WarenkorbAngebot } from '../reducers/produkte.reducer';

export function* watchAngebotsdatumResetLog() {
  yield takeEvery(GlobalActions.SAVED_STATES_LOADED, handleSavedStatesLoadedForLogging);
}

export function* handleSavedStatesLoadedForLogging(action: GlobalAction<WrappedSavedStatesLoaded>): Generator<unknown, void, unknown> {
  try {
    const payload = action.payload;
    const savedStatesLoaded: WrappedSavedStates = payload.savedStatesLoaded;

    const dashboardState = savedStatesLoaded.find(
      loadedState => loadedState.appId === App.SHOP_DASHBOARD
    );

    if (!dashboardState) {
      return;
    }

    const warenkorb = dashboardState.state.warenkorb as Array<WarenkorbAngebot>;
    if (!warenkorb || warenkorb.length === 0) {
      return;
    }

    const logEntries = migrateAngebotsdatumArray(warenkorb, { enableLogging: true });

    for (const logEntry of logEntries) {
      const message = `Angebotsdatum für ${logEntry.versichertesRisiko} laut gespeichertem Angebot: ${logEntry.oldDate}; korrigiert auf ${logEntry.newDate}`;
      PS20Logger.info(App.SHOP_DASHBOARD, message);
    }
  } catch (error) {
    PS20Logger.error(App.SHOP_DASHBOARD, error as Error, 'Failed to log angebotsdatum reset information');
  }
  yield;
}
